import { SyncNotification } from 'common/models/databaseSync/syncNotification';
import { DatabaseSyncStatus } from 'common/models/databaseSync/syncStatus';
import { FC } from 'react';
import { feedbackMessage } from '../utils/functions';
import { StatusLabel, SyncBtnWrapper, SyncButton } from './styles';

export const SyncButtonAndProgress: FC<{
  syncStatusError: boolean;
  syncNotification: SyncNotification;
  onSyncClick: () => void;
  syncInProgress: boolean;
  startingLocally: boolean;
  showModal: boolean;
}> = ({
  syncStatusError,
  syncNotification,
  onSyncClick,
  syncInProgress,
  startingLocally,
  showModal,
}) => {
  return (
    <SyncBtnWrapper>
      <StatusLabel
        isError={
          syncStatusError ||
          syncNotification.status === DatabaseSyncStatus.Failed
        }
      >
        {syncStatusError
          ? 'Error getting sync status.'
          : feedbackMessage(syncNotification)}
      </StatusLabel>
      <SyncButton
        type='button'
        disabled={
          startingLocally || syncInProgress || syncStatusError || showModal
        }
        isStatusError={syncStatusError || showModal}
        onClick={onSyncClick}
      >
        Start Sync
      </SyncButton>
    </SyncBtnWrapper>
  );
};
